import React, { useState, useMemo } from 'react';
import Card from '../../../../shared/components/Card';
import usePageTranslation from '../../../../shared/hooks/usePageTranslation';

const MOCK_BUILDINGS = Array.from({ length: 18 }, (_, i) => ({
  id: String(i + 1),
  name: `CF Médecine ${String(i + 1).padStart(3, '0')}`,
}));

const AllianceBuildings: React.FC = () => {
  const { t } = usePageTranslation('game', 'AlliancePage');
  const [search, setSearch] = useState('');

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return MOCK_BUILDINGS;
    return MOCK_BUILDINGS.filter((b) => b.name.toLowerCase().includes(q));
  }, [search]);

  return (
    <Card className="p-6">
      <h2 className="text-2xl font-bold text-white mb-4">{t('buildings.title')}</h2>
      <div className="relative mb-4">
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
        </span>
        <input
          type="text"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder={t('buildings.searchPlaceholder')}
          className="w-full pl-10 pr-4 py-2.5 rounded-lg bg-gray-800 border border-gray-700 text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
        />
      </div>
      <p className="text-sm font-semibold text-gray-400 mb-2">{t('buildings.colName')}</p>
      <ul className="space-y-1 max-h-[60vh] overflow-y-auto rounded-lg border border-gray-700 divide-y divide-gray-700/50">
        {filtered.length === 0 ? (
          <li className="px-4 py-6 text-center text-gray-500">{t('buildings.noResults')}</li>
        ) : (
          filtered.map((b) => (
            <li key={b.id} className="flex items-center gap-3 px-4 py-3 hover:bg-gray-800/50">
              <span className="flex-shrink-0 w-8 h-8 rounded bg-red-600/80 flex items-center justify-center">
                <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19 3H5c-1.1 0-1.99.9-1.99 2L3 19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 11h-4v4h-4v-4H6v-4h4V6h4v4h4v4z" />
                </svg>
              </span>
              <span className="text-gray-300">{b.name}</span>
            </li>
          ))
        )}
      </ul>
    </Card>
  );
};

export default AllianceBuildings;
